<div [formGroup]="form">
    <app-website-config-form-expansion-panel [title]="'Partner Links'" [firstMarginTop]="true">
        <div formArrayName="partnerLinks">
            @for (partnerLink of partnerLinksArray.controls; let i = $index; track partnerLink) {
            <div [formGroup]="partnerLink" class="admin-row no-border-bottom">

                <mat-form-field appearance="outline" class="form-field-width cell">
                    <mat-label>Name</mat-label>
                    <input matInput formControlName="name">
                    @if(partnerLink.get('name')?.hasError('required')) {
                    <mat-error>Feld darf nicht leer sein</mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline" class="form-field-width cell">
                    <mat-label>URL</mat-label>
                    <input matInput formControlName="url">
                    @if(partnerLink.get('url')?.hasError('invalidUrl')) {
                        <mat-error>{{ partnerLink.get('url')?.getError('invalidUrl') }}</mat-error>
                    } @else if (partnerLink.get('url')?.hasError('required')) {
                        <mat-error>Feld darf nicht leer sein</mat-error>
                    }
                </mat-form-field>

                <mat-checkbox class="cell" formControlName="isActive">Aktiv</mat-checkbox>

                <button mat-icon-button (click)="onDeletePartnerLink(i)">
                    <mat-icon class="admin-error">delete</mat-icon>
                </button>
            </div>
            <mat-divider></mat-divider>
            }
        </div>
        <div class="add-action">
            <button mat-mini-fab (click)="addPartnerLink()">
                <mat-icon class="admin-success">add</mat-icon>
            </button>
        </div>
    </app-website-config-form-expansion-panel>
</div>
